<template>
<b-navbar toggleable="md" type="dark" variant="dark" :sticky="true" v-if="isAuthenticated">
  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  <b-navbar-brand href="/home" to="/home">SAED - L</b-navbar-brand>
  <b-collapse is-nav id="nav_collapse">
    <b-navbar-nav >
      <b-nav-item href="/personal" to="/personal">Personal</b-nav-item>
      <b-nav-item-dropdown text="Configuración" left v-if="isInRoleAdmin || isInRoleCoordinador">
        <b-dropdown-item href="/eventos" to="/configuracion/eventos" v-if="isInRoleAdmin || isInRoleCoordinador ">Eventos</b-dropdown-item>
        <b-dropdown-item href="/regimen" to="/configuracion/regimen" v-if="isInRoleAdmin">Detalle Licencia</b-dropdown-item>
        <b-dropdown-item href="/tipo" to="/configuracion/tipo" v-if="isInRoleAdmin">Tipo Licencia</b-dropdown-item>
        <b-dropdown-item href="/cie10" to="/configuracion/cie10" v-if="isInRoleAdmin">CIE10</b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown text="Reportes" left v-if="isInRoleAdmin || isInRoleCoordinador">
        <b-dropdown-item href="/licenciasbyarticulo" to="/reportes/licenciasbyarticulo" v-if="isInRoleAdmin">Licencias por Articulo</b-dropdown-item>
        <b-dropdown-item href="/solicitudesbyestado" to="/reportes/solicitudesbyestado" v-if="isInRoleAdmin">Solicitudes por estado</b-dropdown-item>
        <b-dropdown-item href="/solicitudesbynivel" to="/reportes/solicitudesbynivel" v-if="isInRoleAdmin">Solicitudes por nivel</b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown text="Licencias" left  v-if="isInRoleAdmin || isInRoleCoordinador || isInRoleEstablecimiento || isInRoleRecMedico">
        <b-dropdown-item href="/consultalicencia" to="/consultalicencia">Consultar</b-dropdown-item>
        <!-- <b-dropdown-item href="/registrarlicencia" v-if="isInRoleAdmin || isInRoleCoordinador" to="/registrarlicencia">Registrar Licencia</b-dropdown-item> -->
      </b-nav-item-dropdown>

      <b-nav-item-dropdown text="Solicitudes" left v-if="isInRoleAdmin || isInRoleEstablecimiento || isInRoleCoordinador || isInRoleRecMedico">
        <b-dropdown-item   href="/consultasolicitud" to="/consultasolicitud">Consultar Solicitudes de Licencias</b-dropdown-item>
        <b-dropdown-item href="/registrarsolicitud" to="/registrarsolicitud" v-if="isInRoleEstablecimiento || isInRoleAdmin ">Registrar Solicitud de Licencia</b-dropdown-item>
        <b-dropdown-divider v-if="isInRoleAdmin || isInRoleRecMedico"></b-dropdown-divider>
        <b-dropdown-item v-if="isInRoleAdmin || isInRoleRecMedico" href="/consultasolicitudaltamedica" to="/consultasolicitudaltamedica">Consultar Solicitudes de Altas Medicas</b-dropdown-item>
        <b-dropdown-item v-if="isInRoleAdmin || isInRoleRecMedico"  href="/registrarsolicitudaltamedica" to="/registrarsolicitudaltamedica">Registrar Solicitud de Alta Medica</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown right v-if="isAuthenticated">
        <!-- Using button-content slot -->
        <template slot="button-content">
          <em>{{ getUserName }}</em>
        </template>
        <b-dropdown-item @click="logoutBtn()">Salir</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-collapse>
</b-navbar>
</template>

<script>
import {mapGetters,mapActions} from 'vuex'
import axios from 'axios';

export default {
  name: 'Navbar',
  computed: {
    ...mapGetters(['isAuthenticated', 'getUserName','getUserInfo','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico'])
  },
  data() {
    return {
      usuario:''
  }
},
  methods: {
    ...mapActions(['logout']),
    logoutBtn() {
      this.logout()
      this.$router.push('/login');
    },
  },
  created(){
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/template/Navbar.vue